import CustomerImg1 from "./assets/images/png/ask-and-associates-customer-img-1.png";
import CustomerImg2 from "./assets/images/png/ask-and-associates-customer-img-2.png";
import CustomerImg3 from "./assets/images/png/ask-and-associates-customer-img-3.png";
import CustomerImg4 from "./assets/images/png/ask-and-associates-customer-img-4.png";
import CustomerImg5 from "./assets/images/png/ask-and-associates-customer-img-5.png";
import CustomerImg6 from "./assets/images/png/ask-and-associates-customer-img-6.png";
import CustomerImg7 from "./assets/images/png/ask-and-associates-customer-img-7.png";
import CustomerImg8 from "./assets/images/png/ask-and-associates-customer-img-8.png";
// import MemberImage1 from "./assets/images/webp/our-team-img-1.webp";
// import MemberImage2 from "./assets/images/webp/our-team-img-2.webp";
// import MemberImage3 from "./assets/images/webp/our-team-img-3.webp";
import MemberImage4 from "./assets/images/webp/our-team-img-4.webp";
import workimage1 from "./assets/images/webp/work-image-1.webp";
import workimage2 from "./assets/images/webp/work-image-2.webp";
import workimage3 from "./assets/images/webp/work-image-3.webp";
import workimage4 from "./assets/images/webp/work-image-4.webp";
import OurServiceImg1 from "./assets/images/webp/our-service-img-1.webp";
import OurServiceImg2 from "./assets/images/webp/our-service-img-2.webp";
import OurServiceImg3 from "./assets/images/webp/our-service-img-3.webp";
import OurServiceImg4 from "./assets/images/webp/our-service-img-4.webp";
import serviceimg1 from "./assets/images/webp/ask-and-associates-space-renewal-and-upgradation-services.webp";
import serviceimg2 from "./assets/images/webp/ask-and-associates-commercial-build-and-development-services.webp";
import serviceimg3 from "./assets/images/webp/ask-and-associates-modern-home-interior-design-services.webp";
import serviceimg4 from "./assets/images/jpg/ask-and-associates-advanced-structural-engineering-solutions.jpg";
import serviceimg5 from "./assets/images/webp/ask-and-associates-foundation-and-base-work-construction-services.webp";
import serviceimg6 from "./assets/images/jpg/ask-and-associates-residential-design-and-build-services.jpg";
import projectimg1 from "./assets/images/jpg/ask-and-associates-royal-residency-residential-architecture.jpg";
import projectimg2 from "./assets/images/jpg/ask-and-associates-vision-srushti-commercial-building-project-asongaon.jpg";
import projectimg3 from "./assets/images/jpg/ask-and-associates-ananta-solapur-residential-project-solapur.jpg";
import projectimg4 from "./assets/images/jpg/ask-and-associates-usha-joshi-park-phase-3-commercial-project-khadavli.jpg";
import projectimg5 from "./assets/images/jpg/ask-and-associates-sky-height-commercial-building-project-padgha.jpg";
import projectimg6 from "./assets/images/jpg/ask-and-associates-patrawala-arcade-commercial-building-bhiwandi.jpg";
import projectimg7 from "./assets/images/jpg/ask-and-associates-pitambre-height-commercial-building-project-khadavli.png";
import projectimg8 from "./assets/images/jpg/ask-and-associates-patil-bungalow-luxury-residential-architecture-project.png";
import projectimg9 from "./assets/images/jpg/ask-and-associates-bhumi-imperial-commercial-architecture-project.jpg";
import projectimg10 from "./assets/images/jpg/ask-and-associates-gul-aziz-residency-apartment-project-purulia-west-bengal.jpg";
import projectimg11 from "./assets/images/jpg/ask-and-associates-sk-farm-commercial-architecture-project.jpg";
import projectimg12 from "./assets/images/jpg/ask-and-associates-silver-stone-commercial-building-project-thane-pathlipada.jpg";
import projectimg13 from "./assets/images/jpg/ask-and-associates-baug-e-suraiyya-commercial-building-project-bhiwandi.jpg";
import projectimg14 from "./assets/images/jpg/ask-and-associates-ashraf-height-commercial-building-project-titwala.jpg";
import projectimg15 from "./assets/images/jpg/ask-and-associates-horizon-bhumi-commercial-highrise-project-austin-tx.jpg";
import projectimg16 from "./assets/images/jpg/ask-and-associates-sumukh-galaxia-commercial-building-project-shelu-karjat.jpg";
import projectimg17 from "./assets/images/jpg/ask-and-associates-karnika-galaxy-2-commercial-highrise-project-diva-agasan.jpg";
import projectimg18 from "./assets/images/jpg/ask-and-associates-mount-city-commercial-architecture-project-austin-tx.jpg";
import projectimg19 from "./assets/images/jpg/ask-and-associates-royal-place-commercial-architecture-project-padgha.jpg";
// import shopimg1 from "./assets/images/webp/shop-image-1.webp";
// import shopimg2 from "./assets/images/webp/shop-image-2.webp";
// import shopimg3 from "./assets/images/webp/shop-image-3.webp";
// import shopimg4 from "./assets/images/webp/shop-image-4.webp";
// import shopimg5 from "./assets/images/webp/shop-image-5.webp";
// import shopimg6 from "./assets/images/webp/shop-image-6.webp";
// import shopimg7 from "./assets/images/webp/shop-image-7.webp";
// import shopimg8 from "./assets/images/webp/shop-image-8.webp";
// import shopimg9 from "./assets/images/webp/shop-image-9.webp";
import blogimg1 from "./assets/images/jpg/ask-and-associates-emerging-design-innovations-modern-architecture.jpg";
import blogimg2 from "./assets/images/jpg/ask-and-associates-how-to-choose-right-contractor-for-construction-project.jpg";
import blogimg3 from "./assets/images/jpg/ask-and-associates-residential-vs-commercial-construction-differences.jpg";
import blogimg4 from "./assets/images/webp/ask-and-associates-project-management-ensures-timely-quality-construction.webp";
import blogimg5 from "./assets/images/webp/ask-and-associates-strong-foundation-design-for-buildings.webp";
import blogimg6 from "./assets/images/webp/ask-and-associates-common-construction-mistakes-how-to-avoid.webp";
import blogimg7 from "./assets/images/webp/ask-and-associates-green-construction-materials-transforming-industry.webp";
import blogimg8 from "./assets/images/jpg/ask-and-associates-future-construction-technology-sustainable-development.jpg";

export const navLinks = [
  {
    id: 1,
    path: "/",
    label: "Home",
  },
  {
    id: 2,
    path: "/about",
    label: "about",
  },
  {
    id: 3,
    path: "/service",
    label: "service",
  },
  {
    id: 4,
    path: "/projects",
    label: "projects",
  },
  // {
  //   id:5,
  //   path:"/shop",
  //   label:"shop"

  // },
  {
    id: 6,
    path: "/blog",
    label: "blog",
  },
];

export const customerReview = [
  {
    id: 1,
    customerReview:
      "The team truly understands design and functionality. They delivered exactly what we imagined, with exceptional attention to detail.",
    customerImage: CustomerImg1,
    customerName: "Rohan Sharma",
    customerDesignation: "Home Owner, Pune",
  },
  {
    id: 2,
    customerReview:
      "Professional, punctual, and highly creative. Our commercial project was handled smoothly from start to finish.",
    customerImage: CustomerImg2,
    customerName: "Ankit Patel",
    customerDesignation: "Business Owner, Mumbai",
  },
  {
    id: 3,
    customerReview:
      "From planning to execution, everything was well-coordinated. Great communication and impressive work quality.",
    customerImage: CustomerImg3,
    customerName: "Amit Desai",
    customerDesignation: "Project Head, Ahmedabad",
  },
  {
    id: 4,
    customerReview:
      "Their design ideas completely transformed our space. Highly satisfied with the final outcome.",
    customerImage: CustomerImg4,
    customerName: "Sneha Kulkarni",
    customerDesignation: "Interior Client, Nagpur",
  },
  {
    id: 5,
    customerReview:
      "Amazing experience. The team delivered on time and maintained excellent workmanship throughout.",
    customerImage: CustomerImg5,
    customerName: "Vikram Singh",
    customerDesignation: "Villa Owner, Jaipur",
  },
  {
    id: 6,
    customerReview:
      "Very reliable and skilled. They proposed practical solutions while keeping aesthetics in mind.",
    customerImage: CustomerImg6,
    customerName: "Megha Nair",
    customerDesignation: "Apartment Owner, Kochi",
  },
  {
    id: 7,
    customerReview:
      "Their project management is top-notch. We didn't have to worry about anything — completely hassle-free.",
    customerImage: CustomerImg7,
    customerName: "Priya Verma",
    customerDesignation: "Developer, Surat",
  },
  {
    id: 8,
    customerReview:
      "Great team to work with! They delivered quality work and kept everything transparent throughout the project.",
    customerImage: CustomerImg8,
    customerName: "Rajesh Gupta",
    customerDesignation: "Owner, Delhi NCR",
  },
];

export const ourTeam = [
  // {
  //   id: 1,
  //   image: MemberImage1,
  //   name: "Amit Sharma",
  //   designation: "Construction Manager",
  // },
  // {
  //   id: 2,
  //   image: MemberImage2,
  //   name: "Rohit Desai",
  //   designation: "Site Supervisor",
  // },
  // {
  //   id: 3,
  //   image: MemberImage3,
  //   name: "Neeraj Kulkarni",
  //   designation: "Project Manager",
  // },
  {
    id: 4,
    image: MemberImage4,
    name: "Faizan Ahmad",
    designation: "Civil Engineer",
  },
];

export const worker = [
  {
    id: 1,
    image: workimage1,
    title: "Planning",
    para: "Our process begins with understanding your vision, requirements, and project goals. We analyze every detail to create a clear and strategic foundation for your project.",
  },
  {
    id: 2,
    image: workimage2,
    title: "Design & Development",
    para: "Once the plan is set, our team transforms concepts into detailed designs and workable solutions. Every element is refined to ensure accuracy, creativity, and functionality.",
  },
  {
    id: 3,
    image: workimage3,
    title: "Construction",
    para: "This is where ideas turn into reality. With precise execution and skilled workmanship, we ensure every phase is completed with quality, safety, and efficiency.",
  },
  {
    id: 4,
    image: workimage4,
    title: "Handover",
    para: "After inspection and quality checks, we deliver the completed project with full transparency and satisfaction. A seamless handover marks the start of your new space.",
  },
];

export const ourServices = [
  {
    id: 1,
    image: OurServiceImg1,
    title: "Residential Design",
    para: "We design and build comfortable, functional, and modern homes with a focus on quality craftsmanship.",
  },
  {
    id: 2,
    image: OurServiceImg2,
    title: "Structural Solutions",
    para: "Our expert engineering solutions ensure strong, safe, and durable structures built to the highest standards.",
  },
  {
    id: 3,
    image: OurServiceImg3,
    title: "Commercial Development",
    para: "From offices to retail spaces, we deliver high-performance commercial environments tailored to your needs.",
  },
  {
    id: 4,
    image: OurServiceImg4,
    title: "Interior Styling",
    para: "We create elegant, functional interiors that reflect your lifestyle while maximizing comfort and aesthetics.",
  },
];

export const ourService = [
  {
    id: 1,
    image: serviceimg1,
    title: "Space Renewal & Upgradation",
  },
  {
    id: 2,
    image: serviceimg2,
    title: "Commercial Build & Development",
  },
  {
    id: 3,
    image: serviceimg3,
    title: "Modern Home Interiors",
  },
  {
    id: 4,
    image: serviceimg4,
    title: "Advanced Structural Solutions",
  },
  {
    id: 5,
    image: serviceimg5,
    title: "Foundation & Base Work",
  },
  {
    id: 6,
    image: serviceimg6,
    title: "Residential Design & Build",
  },
];

export const ourProject = [
  {
    id: 1,
    image: projectimg4,
    linktext: "Commercial / Khadavli",
    title: "Usha Joshi Park Phase III",
  },
  {
    id: 2,
    image: projectimg14,
    linktext: "Commercial / Titwala",
    title: " Height",
  },
  {
    id: 3,
    image: projectimg1,
    linktext: "Commercial / Khadavli",
    title: "Royal Residency",
  },
  {
    id: 4,
    image: projectimg11,
    linktext: "Commercial / Mahapoli",
    title: "SK Farm",
  },
  {
    id: 5,
    image: projectimg9,
    linktext: "Commercial / Grater Thane,Bhiwandi",
    title: "Bhumi Imperial",
  },
  {
    id: 6,
    image: projectimg13,
    linktext: "Commercial / Bhiwandi",
    title: "Baug-E-Suraiyya",
  },
  {
    id: 7,
    image: projectimg7,
    linktext: "Commercial / Khadavli",
    title: "Pitambre Height",
  },
  {
    id: 8,
    image: projectimg8,
    linktext: "Commercial",
    title: "Patil Bungalow",
  },
  {
    id: 9,
    image: projectimg2,
    linktext: "Commercial / Asongaon",
    title: "Vision Srushti",
  },
  {
    id: 10,
    image: projectimg18,
    linktext: "Commercial Austin,TX",
    title: "Mount City",
  },
  {
    id: 11,
    image: projectimg16,
    linktext: "Commercial / Shelu, Karjat",
    title: "Sumukh Galaxia",
  },
  {
    id: 12,
    image: projectimg19,
    linktext: "Commercial / Padgha",
    title: "Royal Place",
  },
  {
    id: 13,
    image: projectimg5,
    linktext: "Commercial / Padgha",
    title: "Sky Height",
  },
  {
    id: 14,
    image: projectimg15,
    linktext: "Commercial Austin,TX",
    title: "Horizon Bhumi",
  },
  {
    id: 15,
    image: projectimg12,
    linktext: "Commercial / Thane Pathlipada",
    title: "Silver Stone",
  },
  {
    id: 16,
    image: projectimg17,
    linktext: "Commercial / Diva Agasan",
    title: "Karnika Galaxy 2.0",
  },
  {
    id: 17,
    image: projectimg10,
    linktext: "Commercial / Purulia West bengal",
    title: "Gul-Aziz Residency",
  },
  {
    id: 18,
    image: projectimg3,
    linktext: "Commercial / Solapur",
    title: "Ananta Solapur",
  },
  {
    id: 19,
    image: projectimg6,
    linktext: "Commercial / Bhiwandi",
    title: "Patrawala Arcade",
  },
];

// export const ourShop = [
//   {
//     id: 1,
//     image: shopimg1,
//     title: "Klein Tools Screwdriver",
//     para: "$ 79.00 USD",
//   },

//   {
//     id: 2,
//     image: shopimg2,
//     title: "Leather Multitool Sheath",
//     para: "$ 254.00 USD",
//   },
//   {
//     id: 3,
//     image: shopimg3,
//     title: "Heavy Duty - Metal Seamer",
//     para: "$ 149.00 USD",
//   },
//   {
//     id: 4,
//     image: shopimg4,
//     title: "Hurricane Metal Cutter",
//     para: "$ 100.00 USD",
//   },
//   {
//     id: 5,
//     image: shopimg5,
//     title: "Dewalt: Chalk Reel",
//     para: "$ 45.99 USD",
//   },
//   {
//     id: 6,
//     image: shopimg6,
//     title: "Framming Spec Hammer",
//     para: "$ 30.00 USD",
//   },
//   {
//     id: 7,
//     image: shopimg7,
//     title: "Scaffolding Set",
//     para: "$ 45.99 USD",
//   },
//   {
//     id: 8,
//     image: shopimg8,
//     title: "Multi-Purpose Range",
//     para: "$ 25.99 USD",
//   },
//   {
//     id: 9,
//     image: shopimg9,
//     title: "Heavy-Duty Hammer",
//     para: "$ 45.99 USD $ 55.32 USD",
//   },
// ];

export const ourBlog = [
  {
    id: 1,
    image: blogimg1,
    date: "January 12, 2025",
    title: "Emerging Design Innovations Shaping Modern Architecture",
    description:
      "Explore the newest architectural concepts and design strategies redefining the way contemporary structures are created.",
  },
  {
    id: 2,
    image: blogimg2,
    date: "January 10, 2025",
    title: "A Complete Guide to Choosing the Right Contractor for Your Project",
    description:
      "Understand the key factors that help you evaluate contractors and ensure a smooth, successful construction journey.",
  },
  {
    id: 3,
    image: blogimg3,
    date: "January 08, 2025",
    title: "Residential vs Commercial Construction: What Sets Them Apart?",
    description:
      "Learn the fundamental differences in planning, design, and execution between residential and commercial projects.",
  },
  {
    id: 4,
    image: blogimg4,
    date: "January 05, 2025",
    title: "How Project Management Ensures Timely & Quality Construction",
    description:
      "Discover how structured planning, coordination, and monitoring lead to efficient and on-time project delivery.",
  },
  {
    id: 5,
    image: blogimg5,
    date: "January 03, 2025",
    title: "Why Strong Foundation Design Is the Heart of Every Structure",
    description:
      "Foundations determine safety and longevity — here's why expert engineering is crucial for every building.",
  },
  {
    id: 6,
    image: blogimg6,
    date: "January 01, 2025",
    title: "Common Construction Mistakes and How to Avoid Them",
    description:
      "Avoid costly delays and structural issues with this guide to the most frequent mistakes made during construction.",
  },
  {
    id: 7,
    image: blogimg7,
    date: "December 28, 2024",
    title: "How Green Construction Materials Are Transforming the Industry",
    description:
      "Sustainable materials are shaping a more responsible future — explore the benefits and modern applications.",
  },
  {
    id: 8,
    image: blogimg8,
    date: "December 26, 2024",
    title: "Building for the Future: Technology Meets Sustainable Development",
    description:
      "Learn how advanced tech and eco-friendly practices are creating smarter, more resilient construction solutions.",
  },
];

export const featuredProjects = [
  {
    id: 3,
    image: projectimg1,
    linktext: "Commercial / Khadavli",
    title: "Royal Residency",
  },
  {
    id: 4,
    image: projectimg11,
    linktext: "Commercial / Mahapoli",
    title: "SK Farm",
  },
  {
    id: 12,
    image: projectimg19,
    linktext: "Commercial / Padgha",
    title: "Royal Place",
  },
];

export const latestNews = [
  {
    id: 1,
    image: blogimg1,
    date: "January 12, 2025",
    title: "Emerging Design Innovations Shaping Modern Architecture",
    description:
      "Explore the newest architectural concepts and design strategies redefining the way contemporary structures are created.",
  },
  {
    id: 2,
    image: blogimg2,
    date: "January 10, 2025",
    title: "A Complete Guide to Choosing the Right Contractor for Your Project",
    description:
      "Understand the key factors that help you evaluate contractors and ensure a smooth, successful construction journey.",
  },
  {
    id: 3,
    image: blogimg3,
    date: "January 08, 2025",
    title: "Residential vs Commercial Construction: What Sets Them Apart?",
    description:
      "Learn the fundamental differences in planning, design, and execution between residential and commercial projects.",
  },
];
